<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input v-model="searchText" search placeholder="搜索母液..." @on-change="searchMLCost" clearable icon="ios-search"
          style="width: 250px; margin-right: 30px">
        </Input>
        <Select placeholder="筛选工厂" v-model="selectedFactory" label-in-value multiple @on-clear="initList"
          @on-change="choseFactory" style="width: 200px; margin-right: 30px">
          <Option v-for="item in factoryList" :value="item._id" :key="item._id">{{ item.name }}</Option>
        </Select>
        <Select placeholder="筛选标签" v-model="selectedTags" label-in-value multiple @on-clear="initList"
          @on-change="choseTags" style="width: 220px">
          <Option v-for="item in tagList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <div class="semi-contrast-wrap" @click="$router.push('/home/SemiContrast')">
          <div class="semi-contras">母液对比</div>
        </div>
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page :total="totalRows" :page-size="50" @on-change="loadCaclMLCost" show-total simple />
          <Button type="primary" @click="caclAllMLCost()">计算全部成本</Button>
        </div>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table border :loading="tableLoading" :columns="columns" :data="semiItemCostList" :height="tableHeight"></Table>
    </div>
    <CaclMLDetailDrawer ref="CaclMLDetailDrawer" />
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import CaclMLDetailDrawer from "./CaclMLDetailDrawer";

export default {
  name: "caclMLCost",
  components: { CaclMLDetailDrawer },
  data() {
    return {
      page: 0,
      tableHeight: 300,
      tableLoading: false,
      searchText: "",
      totalRows: undefined,
      latestMLCost: undefined,
      selectedFactory: [],
      selectedTags: [],
      filterQuery: { limit: 50 },
      columns: [
        {
          title: "材料名称",
          key: "material",
          width: 150,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { color: "#42b983", cursor: "pointer" },
                on: {
                  click: () => {
                    this.$refs.CaclMLDetailDrawer.openDrawer(params.row._id);
                  },
                },
              },
              params.row.material.model
            );
          },
        },
        {
          title: "工厂",
          key: "factory",
          align: "left",
          width: 150,
          render: (h, params) => {
            return h("span", _.get(params.row, "factory.name", ""));
          },
        },
        {
          title: "单个固含成本",
          key: "unitCostPerSoidContent",
          align: "right",
          sortable: true,
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(
                params.row,
                "calcSemiCost.unitCostPerSoidContent",
                "",
                2
              )
            );
          },
        },
        {
          title: "总成本",
          key: "totalCost",
          align: "right",
          sortable: true,
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(params.row, "calcSemiCost.totalCost")
              // _.get(params.row, "calcSemiCost.totalCost", "").toFixed(0)
            );
          },
        },
        {
          title: "含固量",
          key: "solidContent",
          align: "right",
          sortable: true,
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(params.row, "calcSemiCost.solidContent", "%", 2)
            );
          },
        },
        {
          title: "材料成本",
          key: "materialCost",
          align: "right",
          sortable: true,
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(params.row, "calcSemiCost.materialCost")
            );
          },
        },
        {
          title: "制造费",
          key: "manufactCost",
          align: "right",
          sortable: true,
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(params.row, "calcSemiCost.manufactCost")
            );
          },
        },
        {
          title: "运费",
          key: "manufactCost",
          align: "right",
          sortable: true,
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              this.adjustNumber(params.row, "calcSemiCost.importSemiTransCost")
            );
          },
        },
        {
          title: "发货工厂",
          key: "factory",
          align: "right",
          width: 150,
          render: (h, params) => {
            return h(
              "span",
              _.get(
                params.row,
                "calcSemiCost.calcFromSemiItem.factory.name",
                ""
              )
            );
          },
        },
        {
          title: "核算日期",
          key: "manufactCost",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h(
              "span",
              params.row.calcSemiCost
                ? dayjs(params.row.calcSemiCost.createdAt).format(
                  "YYYY-MM-DD HH:mm"
                )
                : ""
            );
          },
        },
        {
          title: "成本核算",
          key: "oneSemiCalc",
          align: "center",
          maxWidth: 120,
          minWidth: 80,
          render: (h, params) => {
            return h(
              "h4",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#2D8CF0",
                  cursor: "pointer",
                  borderRadius: "4px",
                  border: "1px solid #2D8CF0",
                },
                on: {
                  click: () => {
                    this.calcOneSemiCost(params.row._id);
                  },
                },
              },
              "成本核算"
            );
          },
        },
      ],
      tagList: [
        {
          value: "jianshui",
          label: "减水",
        },
        {
          value: "baotan",
          label: "保坍",
        },
        {
          value: "zaoqiang",
          label: "早强",
        },
        {
          value: "6c",
          label: "6碳",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
      semiItemCostList: (state) => state.calcSemiCost.semiItemCostList,
    }),
  },
  methods: {
    ...mapActions({
      caclSemiCost: "calcSemiCost/caclSemiCostAction",
      getSemiLatestCost: "calcSemiCost/getSemiLatestCostAction",
      getFactorys: "factory/getFactorysAction",
    }),
    adjustNumber(params, numberString, appendString, toFixedNumber) {
      const value = _.get(params, numberString, "");
      if (typeof value === "number") {
        return appendString
          ? value.toFixed(toFixedNumber ?? 0) + appendString
          : value.toFixed(toFixedNumber ?? 0);
      }
    },
    searchMLCost: _.debounce(function () {
      this.page = 0;
      this.loadCaclMLCost();
    }, 1000),
    async loadCaclMLCost(page) {
      await this.getFactorys();
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 15,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.semiName = this.searchText;
      } else {
        delete this.filterQuery.semiName;
      }
      this.tableLoading = true;
      await this.getSemiLatestCost(this.filterQuery);
      this.tableLoading = false;
      // for (let i = 0; i < this.factoryList.length; i++) {
      //   const factoryId = this.factoryList[i]._id;
      //   let factory = {};
      //   factory.key = `factory${i}`;
      //   factory.minWidth = 95;
      //   factory.align = "right";
      //   factory.renderHeader = (h, params) => {
      //     return h("div", this.factoryList[i].name);
      //   };
      //   factory.render = (h, params) => {
      //     for (let i = 0; i < params.row.price.length; i++) {
      //       if (params.row.price[i]) {
      //         if (
      //           params.row.price[i].factory === factoryId &&
      //           params.row.price[i].latestCost
      //         ) {
      //           const mlLatestCost = parseInt(params.row.price[i].latestCost);
      //           return h(
      //             "div",
      //             {
      //               on: {
      //                 click: () => {
      //                   this.$refs.CaclMLDetailDrawer.openDrawer(
      //                     params.row.price[i].latestPriceRef
      //                   );
      //                 },
      //               },
      //               style: { cursor: "pointer" },
      //             },
      //             mlLatestCost
      //           );
      //         }
      //       }
      //     }
      //   };
      //   if (this.columns.length <= this.factoryList.length + 1) {
      //     this.columns.splice(2, 0, factory);
      //   }
      // }
    },

    initList() {
      this.loadCaclMLCost();
    },

    choseFactory(e) {
      if (e.length > 0) {
        const factory = e.map((x) => x.value).join(",");
        this.filterQuery.factory = factory;
      } else {
        delete this.filterQuery.factory;
      }
      this.loadCaclMLCost();
    },
    choseTags(e) {
      if (e.length > 0) {
        const tag = e.map((x) => x.value).join(",");
        this.filterQuery.tags = tag;
      } else {
        delete this.filterQuery.tags;
      }
      this.loadCaclMLCost();
    },

    async caclAllMLCost() {
      try {
        const data = await this.caclSemiCost();
        if (data.calcError.length > 0) {
          this.$Message.error("计算失败：" + data.calcError[0]);
        } else {
          this.$Message.success("计算完成");
        }
        this.loadCaclMLCost();
      } catch (error) {
        this.$Message.error("计算失败", error);
      }
    },
    async calcOneSemiCost(semiItem) {
      const form = {};
      form._id = semiItem;
      try {
        const data = await this.caclSemiCost(form);
        // this.loadCaclMLCost();
        await this.getSemiLatestCost({ _id: semiItem, update: true });
        if (data.calcError.length > 0) {
          this.$Message.error("计算失败：" + data.calcError[0]);
        } else {
          this.$Message.success("计算完成");
        }
      } catch (error) {
        this.$Message.error("计算失败", error);
      }
      // form.factory = data;
      // await this.caclOneML()
    },
  },
  created() {
    this.loadCaclMLCost();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.semi-contrast-wrap
  cursor pointer
  margin-right 20px
  color #2D8CF0

.semi-contrast-wrap:hover
  border-bottom 1px solid #2D8CF0

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>